/* global wp */
import { get } from 'lodash'
import Login from './components/login'
import NoAccess from './components/no-access'
import Dashboard from './components/dashboard'
import Syncing from './components/syncing'
import TeamSelection from './components/team-selection'

const HubConnector = () => {
	const {
		has_access,
		is_syncing,
		is_logged_in,
		is_team_selection
	} = get(window, 'hubConnectorVars', false)

	// If no access.
	if (!has_access) {
		return <NoAccess/>
	}

	// If not logged in and team selection.
	if (!is_logged_in && is_team_selection) {
		return <TeamSelection/>
	}

	// If not logged in.
	if (!is_logged_in) {
		return <Login/>
	}

	// If syncing.
	if (is_syncing) {
		return <Syncing/>
	}

	return <Dashboard/>
}

export default HubConnector
